exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".block{height:1rem;width:1rem;margin:.25rem;list-style:none;display:inline-block;border:1px solid #333}.block.red{background-color:#ff3a24}.block.orange{background-color:#e67e22}.block.yellow{background-color:#f1c40f}.block.green{background-color:#2ecc71}.block.turquoise{background-color:#1abc9c}.block.blue{background-color:#3498db}.block.purple{background-color:#9b59b6}.block.pink{background-color:#ff2470}.block.lightGray{background-color:#ecf0f1}.block.darkGray{background-color:#95a5a6}.block.black{background-color:#34495e}.block.white{background-color:#fff}.block.new{background-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-954b0986!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/Block.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-954b0986!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/Block.vue
// module chunks = 0